<template>
  <div class="content pure-content">
    <div class="action-bar">
      <div class="action-left">
        <el-select v-model="status" placeholder="全部状态" size="small" clearable>
          <el-option v-for="status in statusList" :key="status.key" :value="status.key" :label="status.name"></el-option>
          <el-option v-auth="'pre_invoice'" :value="7" label="已开具，待回款"></el-option>
        </el-select>
      </div>
      <div class="action-right">
        <el-button size="small" @click="downloadReport">报表下载</el-button>
        <el-date-picker v-model="date" type="daterange" size="small" :picker-options="pickerOptions" :default-value="defaultDate" value-format="yyyy/MM/dd"></el-date-picker>
      </div>
    </div>
    <div class="list-body">
      <el-table :data="list" border :height="listBodyHeight" size="small" v-loading="loading">
        <el-table-column v-for="col in columns" :key="col.name" :label="col.label" :prop="col.name" :min-width="col.width">
          <template slot-scope="scope">
            <template v-if="col.name == 'invoiceUrl'">
              <div v-if="scope.row.invoiceUrl && scope.row.invoiceUrl.length">
                <p v-for="url in scope.row.invoiceUrl"><a :href="url" :key="url" target="_blank">{{url | invoiceUrl}}</a></p>
              </div>
              <div v-else>-</div>
            </template>
            <div v-else>{{col.formatter ? col.formatter(scope.row) : scope.row[col.name]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.currentPage"
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        :background="true"
        layout="total, prev, pager, next, jumper, sizes"
        :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import {getInvoiceList} from '../utils/api.js';
  import mixins from '../utils/mixins.js';
  export default {
    name: 'invoice-list',
    mixins: [mixins],
    props: {
      auth: Object
    },
    data() {
      return {
        status: '',
        statusList: [
          {name : "未申请", key : 1},
          {name : "已开票", key : 2},
          {name : "开票中", key : 3},
          {name : "审核驳回", key : 4},
          {name : "不开具", key : 5},
          {name : "审核通过", key : 6},
          {name : "已开具，待回款", key : 7},
          {name : "审核中", key : 8},
          {name : "开票失败", key : 9},
          {name : "发票作废", key : 10},
          {name : "开票中", key : 11},
          {name : "部分红冲", key : 12},
          {name : "全部红冲", key : 13}
        ],
        columns: [
          {label: '发票申请单ID', name: 'applyId', width: 150},
          {label: '发票颜色', name: 'invoiceColorFormat', width: 100},
          {label: '发票代码', name: 'invoiceCode', width: 100},
          {label: '提交时间', name: 'applyTimeFormat', width: 150},
          {label: '开具时间', name: 'openInvoiceTimeFormat', width: 150},
          {label: '发票抬头', name: 'paymentCompanyName', width: 150},
          {label: '发票金额(元)', name: 'amount', width: 100},
          {label: '发票类型', name: 'invoiceTypeFormat', width: 130},
          {label: '发票号码', name: 'invoiceNum', width: 100, formatter: function(row) {
            return row.invoiceNum || '-';
          }},{label: '发票链接', name: 'invoiceUrl', width: 100},
          {label: '快递单号', name: 'trackingNum', width: 130, formatter: function(row) {
            return row.trackingNum || '-';
          }},
          {label: '当前状态', name: 'statusFormat', width: 100},
          {label: '审核信息', name: 'checkMark', width: 140},
          {label: '发票备注', name: 'invoiceDesc', width: 140}
        ]
      }
    },
    computed: {
      isShowAccountId() {
        return this.$route.params && ['core', 'agent'].includes(this.$route.params.type);
      }
    },
    watch: {
      status() {
        this.page.currentPage = 1;
        this.getDataList();
      }
    },
    filters: {
      invoiceUrl(url) {
        if(!url) {
          return '-';
        }
        const reg = /(\.(xml|pdf|ofd))/ig;
        const matches = url.match(reg);
        if(matches && matches.length) {
          return '发票链接 ' + matches[0].replace('.', '');
        }
        return '发票链接';
      }
    },
    created() {
      this.getDataList();
    },
    methods: {
      downloadReport() {
        let params = {
          status: this.status,
          sdate: this.date && this.date.length ? this.date[0] : '',
          edate: this.date && this.date.length ? this.date[1] : ''
        }
        Object.assign(params, window.GLOBAL.userInfo);
        let search = Object.keys(params).map(key => {
          return `${encodeURIComponent(key)}=${params[key]}`;
        }).join('&');
        window.open('/v2/finance/invoice/list/export?' + search);
      },
      search() {
        this.page.currentPage = 1;
        this.getDataList();
      },
      async getDataList() {
        let params = {
          status: this.status,
          sdate: this.date && this.date.length ? this.date[0] : '',
          edate: this.date && this.date.length ? this.date[1] : '',
          page: this.page.currentPage,
          pagesize: this.page.pageSize
        }
        this.loading = true;
        let result = await getInvoiceList(params);
        if (result) {
          this.list = result.list || [];
          this.page.total = result.conf.totalnum;
        }
        this.loading = false;
      },
    }
  };
</script>